module.exports = __webpack_public_path__ + "img/tpc-10.c8ff10a2.webp";